<template>
    <v-container fluid>
        <v-data-table
                :headers="headers"
                :items="ordersClient"
                class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Заказы</v-toolbar-title>
                    <v-divider
                            class="mx-4"
                            inset
                            vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>

            <template v-slot:item.status="{ item }">
                {{statuses.find(status => status.value == item.status).text}}
            </template>
            <template v-slot:item.payed="{ item }">
                {{payed.find(status => status.value == item.payed).text}}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{getDateOutUnixTime(item.created_at) + ' ' + getTimeOutUnixTime(item.created_at)}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn
                        text
                        fab
                        small
                        :href="'/bot' + $route.params.pathMatch + '/order/' + item.id"
                        target="_blank"
                >
                    <v-icon
                            small
                            class="mr-2"

                    >
                        launch
                    </v-icon>
                </v-btn>

            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from 'axios'
import constconf from '../../../../constconf'
import timeHelpers from '../../../../scripts/helpers/timeHelpers'
import { mapGetters } from 'vuex'
export default {
    name: 'OrdersClient',
    data() {
        return {
            ordersClient: [],
            headers: [
                {
                    text: 'Название',
                    align: 'left',
                    sortable: false,
                    value: 'title'
                },
                { text: 'Сформирован', value: 'created_at' },
                { text: 'Оплачен', value: 'payed' },
                { text: 'Статус', value: 'status' },
                { text: 'Сумма', value: 'price' },
                { text: ' ', value: 'action' }
            ],
            statuses: [
                { value: null, text: '' },
                { value: 3, text: 'ожидает обработки' },
                { value: 4, text: 'не дозвонились' },
                { value: 5, text: 'подтвержден' },
                { value: 6, text: 'отменен' },
                { value: 7, text: 'оплачен' },
                { value: 8, text: 'возвращен' },
                { value: 9, text: 'готов к отправке' },
                { value: 10, text: 'отправлен' },
                { value: 11, text: 'доставлен' },
                { value: 12, text: 'выдан' }
            ],
            payed: [ { value: null, text: '' }, { value: 0, text: 'Не оплачен' }, { value: 1, text: 'Оплачен' } ]
        }
    },
    props: ['clientId', 'clientModel', 'selectedMenu'],
    computed: {
        ...mapGetters({
            clients: 'clients/clients'
        })
    },
    methods: {
        loadOrders() {
            console.log('123')
            axios.get(constconf.shop.url + '/card/get-client-orders/' + this.$route.params['pathMatch'] + '?userId=' + this.clientId).then(response => {
                if (response.data.ok) {
                    this.ordersClient = response.data.response.data
                } else {
                    this.ordersClient = []
                }
            })
        },
        ...timeHelpers
    },
    watch: {
        selectedMenu(value) {
            if (value === 3) { // если в clientForm выбрали меню с переменными
                this.loadOrders()
            }
        }
    }
}
</script>

<style scoped>

</style>
